module.exports = __webpack_public_path__ + "img/banner-02.dca39160.png";